import React from "react";
import moment from "moment";
import { Tag } from "antd";
import { NoDecimalFormat, SingleDecimalFormat, TwoDecimalFormat } from "@components/Format";
import { useSelector } from "react-redux";
import { useSmartNavigate } from "@/hooks/use-smart-navigate";
import { buildFacilityPath, getFacilityContext } from "@/utils/route-context";

const formatDate = (value) => {
  if (!value) return "-";
  const parsed = moment(value);
  return parsed.isValid() ? parsed.format("YYYY-MM-DD") : value;
};

const formatServiceMonth = (value) => {
  if (!value) return "-";
  const parsed = moment(value);
  return parsed.isValid() ? parsed.format("YYYY-MM") : value;
};

const formatDateRange = (startDate, endDate) => {
  const start = formatDate(startDate);
  const end = formatDate(endDate);
  if (start === "-" && end === "-") return "-";
  return `${start} - ${end}`;
};

const formatUsage = (value, unit) => {
  if (value == null || value === "") return "-";
  if (unit === "MMBtu") return TwoDecimalFormat(value);
  return NoDecimalFormat(value);
};

const formatAvgOat = (value) => {
  if (value == null || value === "") return "-";
  return SingleDecimalFormat(value);
};

const StatusTag = ({ certified }) => (
  <Tag color={certified ? "green" : "red"} className="utility-mobile-card-status-tag">
    {certified ? "Certified" : "Uncertified"}
  </Tag>
);

export const createUtilityMobileHeader = ({
  detailPathPrefix,
  usageUnit,
}) => {
  return function UtilityMobileHeader({ record }) {
    const { navigateAndCloseTabs } = useSmartNavigate();
    const facilityContext = useSelector((state) => getFacilityContext(state));

    const title = formatServiceMonth(record?.service_month);
    const date = formatDateRange(record?.service_start_date, record?.end_start_date);
    const usage = formatUsage(record?.usage, usageUnit);
    const avgOat = formatAvgOat(record?.avgoat);
    const certified = record?.is_eui_certified === true;

    const handleTitleClick = (e) => {
      e.stopPropagation();
      const nextPath = buildFacilityPath(`${detailPathPrefix}${record?.id}`, facilityContext);
      if (!nextPath) return;
      navigateAndCloseTabs(nextPath, {
        viewType: "facility",
        leafPrefix: `${detailPathPrefix}`,
      });
    };

    return (
      <div className="utility-mobile-card">
        <div className="utility-mobile-card-main">
          <span
            className="utility-mobile-card-title utility-mobile-card-title-link"
            title={title || ""}
            onClick={handleTitleClick}
          >
            {title}
          </span>
          <span className="utility-mobile-card-date" title={date}>
            {date}
          </span>
          <StatusTag certified={certified} />
        </div>
        <div className="utility-mobile-card-summary">
          <span className="utility-mobile-card-meta">
            <span className="utility-mobile-card-meta-label">Usage: </span>
            <span className="utility-mobile-card-meta-value">{usage}</span>
            <span className="utility-mobile-card-meta-suffix">{usageUnit}</span>
          </span>
          <span className="utility-mobile-card-meta">
            <span className="utility-mobile-card-meta-label">Avg. OAT: </span>
            <span className="utility-mobile-card-meta-value">{avgOat}</span>
            <span className="utility-mobile-card-meta-suffix">{"\u00b0F"}</span>
          </span>
        </div>
      </div>
    );
  };
};
